import { key } from 'styled-theme';

export const getFlaskColor = ({ variant, isReversed }) =>
  isReversed ? key(`flasks.${variant}[0]`) : '#fff';

export const getFlaskBackgroundImage = ({ variant, isReversed }) =>
  isReversed
    ? 'linear-gradient(to bottom, #fff, #ececec)'
    : key(`flasks.${variant}[1]`);
